const API = process.env.REACT_APP_BACKEND_URL;

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

export function trackMetaEvent(eventName, customData = null) {
  // Browser pixel (already fires PageView globally; this handles custom events)
  if (window.fbq) {
    if (customData) {
      window.fbq('track', eventName, customData);
    } else {
      window.fbq('track', eventName);
    }
  }

  // Server-side CAPI (fire-and-forget)
  const payload = {
    event_name: eventName,
    event_source_url: window.location.href,
    user_agent: navigator.userAgent,
    fbc: getCookie('_fbc') || null,
    fbp: getCookie('_fbp') || null,
  };
  if (customData) payload.custom_data = customData;

  fetch(`${API}/api/meta/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {}); // silent fail — tracking should never break the app
}
